import { CONTACT } from "@/lib/site";
import { Mail, Phone, MapPin } from "lucide-react";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const team = [
  { name: "Alex Smith", initials: "AS", role: "CEO", bio: "Steers the ship at Shine and Line. Spent years on the tools before turning it into a proper Rangiora outfit - now obsesses about consistent quality on every job." },
  { name: "Samuel Dobbs", initials: "SD", role: "Sales & Marketing Manager", bio: "Your first point of contact. Books the jobs, sorts the quotes and makes sure expectations match reality on the day." },
];

export default function WhoWeAre() {
  useDocumentMeta({
    title: "About Us | Shine and Line Services - Rangiora's Local Crew",
    description: "Meet the team behind Shine and Line Services - a locally owned Rangiora outfit specialising in pressure washing and continuous LED pathway lighting.",
  });
  return (
    <div>
      <section className="border-b border-gray-100 bg-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 sm:py-20" data-testid="who-header">
          <div className="text-xs uppercase tracking-widest text-[#0369A1] font-semibold">Who we are</div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#111827] mt-3 leading-[1.04]">
            Two locals.<br /><span className="glow-underline">One tidy crew.</span>
          </h1>
          <p className="mt-5 text-[#4B5563] max-w-2xl leading-relaxed">We&apos;re a Rangiora-based outfit focused on doing two things really well: bringing concrete back to life and lighting pathways properly. Here&apos;s the team behind the gear.</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {team.map((p, i) => (
            <article key={p.name} className="reveal ba-card rounded-3xl bg-white border border-gray-100 p-8" style={{ animationDelay: `${i * 90}ms` }} data-testid={`team-${i}`}>
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0369A1] to-[#0EA5E9] flex items-center justify-center text-white font-heading text-xl font-bold shadow-sm">
                  {p.initials}
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#0369A1] font-semibold">{p.role}</div>
                  <h3 className="font-heading text-2xl font-bold text-[#111827] mt-0.5">{p.name}</h3>
                </div>
              </div>
              <p className="mt-5 text-sm text-[#4B5563] leading-relaxed">{p.bio}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl border border-gray-100 p-6 bg-[#F9F9FB]">
            <Phone className="w-5 h-5 text-[#0369A1]" />
            <div className="font-heading text-lg font-semibold mt-3">Call Samuel</div>
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="mt-1 inline-block text-[#0369A1] hover:underline" data-testid="who-phone">{CONTACT.phone}</a>
          </div>
          <div className="rounded-2xl border border-gray-100 p-6 bg-[#F9F9FB]">
            <Mail className="w-5 h-5 text-[#0369A1]" />
            <div className="font-heading text-lg font-semibold mt-3">Email us</div>
            <a href={`mailto:${CONTACT.email}`} className="mt-1 inline-block text-[#0369A1] hover:underline break-all" data-testid="who-email">{CONTACT.email}</a>
          </div>
          <div className="rounded-2xl border border-gray-100 p-6 bg-[#F9F9FB]">
            <MapPin className="w-5 h-5 text-[#0369A1]" />
            <div className="font-heading text-lg font-semibold mt-3">Based in</div>
            <div className="mt-1 text-[#4B5563]">{CONTACT.location}</div>
          </div>
        </div>
      </section>
    </div>
  );
}
